const fs = require("fs");
const nconf = require("nconf");
const Immutable = require("immutable");
const iconsPreval = require("./preval/icons.preval");
const icons = Immutable.fromJS(iconsPreval);
const iconData = JSON.stringify(icons);

nconf.argv();
const generateToFile = nconf.get("to-file");

const writeFile = (data) => {
  fs.writeFile("icons.json", data, "utf8", (err) => {
    if (err) {
      console.error("Error writing JSON file:", err);
    } else {
      console.log("JSON file has been saved successfully.");
    }
  });
};

const generate = (data, toFile) => {
  if (!toFile) {
    console.log(data);
  }
  return toFile ? writeFile(data) : data;
}

// Export the function writeFile as default
module.exports = generate(iconData, generateToFile);